import { Injectable } from '@angular/core';
import { ImageDto } from '@picflow/types';
import {
  getAperture,
  getCamera,
  getCaptureTime,
  getCopyright,
  getCreator,
  getExifDescription,
  getExifRating,
  getFocalLength,
  getIso,
  getLens,
  getShutterSpeed,
} from '../lib/extract-exif';

export interface NormalizedExif {
  captureTime: number;
  aperture: string;
  shutterSpeed: string;
  iso: string;
  focalLength: string;
  creator: string;
  lens: string;
  camera: string;
  copyright: string;
  description: string;
  rating: number;
}

@Injectable({
  providedIn: 'root',
})
export class ExifService {
  constructor() {}

  public getExif(image: ImageDto): NormalizedExif {
    const exif = image.version_data.exif;

    const data: NormalizedExif = {
      captureTime: getCaptureTime(exif),
      shutterSpeed: getShutterSpeed(exif),
      aperture: getAperture(exif),
      iso: getIso(exif),
      focalLength: getFocalLength(exif),
      camera: getCamera(exif),
      lens: getLens(exif),
      creator: getCreator(exif),
      copyright: getCopyright(exif),
      description: getExifDescription(exif),
      rating: getExifRating(exif),
    };

    if (!Object.entries(data).length) return;

    return data;
  }
}
